export const USER_CONTRACT_DOMICILIATION = `
<div style="margin: auto;">
<p style="font-weight: 600; font-size: 14px;">Instruyo y autorizo que, con base en la información que se indica en esta comunicación, se realicen cargos periódicos en mi cuenta conforme a lo siguiente:</p>
<ul style="margin-top: 25px; list-style: number;">
    <li style="margin-top: 15px; font-size: 14px">
        Nombre del proveedor del bien, servicio o crédito o préstamo, según corresponda, que pretende pagarse por 
        medio de la presente domiciliación: <strong style="text-decoration: underline; color: #136176;">Monific, S. A. de C. V., Institución de Financiamiento Colectivo.</strong>
    </li>
    <li style="margin-top: 15px; font-size: 14px">
        Bien, servicio o crédito o préstamo, a pagar <span style="text-decoration: underline;">consistente en fondeo de recursos para realizar inversiones de financiamiento colectivo.</span>
    </li>
    <li style="margin-top: 15px; font-size: 14px">
        Periodicidad del pago (Facturación): <strong style="text-decoration: underline; color: #136176;">{{viewValue}}.</strong>
    </li>
    <li style="margin-top: 15px; font-size: 14px">
        Nombre del banco que lleva la cuenta de depósito a la vista o de ahorro en la que se realizará el cargo: <strong style="color: #136176;">{{bankName}}</strong>.
    </li>
    <li style="margin-top: 15px; font-size: 14px">
        Cualquiera de los datos de identificación de la cuenta, siguientes:<br>
        Clave Bancaria Estandarizada (“CLABE”) de la Cuenta (18 dígitos): <strong style="color: #136176;">{{clabe}}</strong>.
    </li>
    <li style="margin-top: 15px; font-size: 14px">
        Monto fijo del cargo autorizado por el periodo de facturación: <strong style="color: #136176;">$ {{amountToRecollect}} MXN</strong>.
    </li>
    <li style="margin-top: 15px; font-size: 14px">
        Esta instrucción y autorización de cargo a mi cuenta se mantendrá vigente por plazo<span style="text-decoration: underline;"> indeterminado</span>.
    </li>
</ul>
<p style="margin: 28px auto 20px auto; font-weight: 600; font-size: 14px;">Estoy enterado de que en cualquier momento podré solicitar la cancelación de la presente domiciliación sin costo a mi cargo.</p>
</div>

<div style="margin-top: 65px;">
<hr width="35%" style="margin: auto; display: block">
<p style="text-align: center; font-weight: 600; font-size: 14px; margin-top: 10px;">{{name}}</p>
</div>
`